import * as Yup from 'yup';

export const validationSchemaNew = Yup.object({
  proofOfIdentityType: Yup.string().nullable(true).required('Povinná položka'),
  proofOfIdentityValue: Yup.string().nullable(true).required('Povinná položka'),
  researchTopic: Yup.string().nullable(true).required('Povinná položka'),
  researchCategories: Yup.array().required('Povinná položka'),
  type: Yup.string().nullable(true).required('Povinná položka'),
  legalEntityName: Yup.mixed().test('Název právnické osoby', '', validateLegalEntityName),
  legalEntityOffice: Yup.object({
    municipality: Yup.mixed().test('Adresa právnické osoby - Obec', '', validateLegalEntityOffice),
    street: Yup.mixed().test('Adresa právnické osoby - Ulice', '', validateLegalEntityOffice),
    zip: Yup.mixed().test('Adresa právnické osoby - PSČ', '', validateLegalEntityOffice),
  }),
  confirmation: Yup.boolean().nullable(true).required('Musíte udělit souhlas').oneOf([true], 'Musíte udělit souhlas'),
});

export const validationSchemaRework = Yup.object({
  proofOfIdentityType: Yup.string().nullable(true).required('Povinná položka'),
  proofOfIdentityValue: Yup.string().nullable(true).required('Povinná položka'),
  researchTopic: Yup.string().nullable(true).required('Povinná položka'),
  researchCategories: Yup.array().required('Povinná položka'),
  type: Yup.string().nullable(true).required('Povinná položka'),
  legalEntityName: Yup.mixed().test('Název právnické osoby', '', validateLegalEntityName),
  legalEntityOffice: Yup.object({
    municipality: Yup.mixed().test('Adresa právnické osoby - Obec', '', validateLegalEntityOffice),
    street: Yup.mixed().test('Adresa právnické osoby - Ulice', '', validateLegalEntityOffice),
    zip: Yup.mixed().test('Adresa právnické osoby - PSČ', '', validateLegalEntityOffice),
  }),
});

function validateLegalEntityName(value) {
  const lastIndex = (this?.from?.length ?? 1) - 1;
  const values = this?.from?.[lastIndex]?.value ?? {};
  const { createError, path } = this;

  const isCredential = values?.type === 'CREDENTIAL';

  if (isCredential && !value) {
    return createError({
      path,
      message: `Povinná položka`,
    });
  }
}

function validateLegalEntityOffice(value) {
  const lastIndex = (this?.from?.length ?? 1) - 1;
  const values = this?.from?.[lastIndex]?.value ?? {};
  const { createError, path } = this;

  const isCredential = values?.type === 'CREDENTIAL';

  if (isCredential && !value) {
    return createError({
      path,
      message: `Povinná položka`,
    });
  }
}
